"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchFlyoutContent = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _PromptFlyoutContent = require("./PromptRecommendations/PromptFlyoutContent");
var _CustomSuggestionsFlyoutItems = _interopRequireDefault(require("../CustomSuggestionsFlyoutItems"));
var _SearchComparisonCardsContent = require("./DropdownWidget/SearchComparisonCardsContent");
var _DomainSearchBox = require("../styles/DomainSearchBox");
const DropdownContentBlock = ({
  children,
  styling,
  className
}) => {
  return /*#__PURE__*/_react.default.createElement(_DomainSearchBox.StyledDropdownContentBlock, {
    "data-testid": "domain-search-custom-flyout",
    "data-cy": "domain-search-custom-flyout",
    id: "domain-search-custom-flyout",
    styling: styling,
    className: (0, _classnames.default)('domain-search-custom-flyout border-0 d-flex justify-content-between ux-sibling-set-vertical ux-sibling-set--stretch', className)
  }, children);
};
DropdownContentBlock.propTypes = {
  children: _propTypes.default.node,
  styling: _propTypes.default.object,
  className: _propTypes.default.string
};
const SearchFlyoutContent = props => {
  const {
    onConfirmCustomSuggestHandler,
    showCustomSuggestions,
    showPromptRecommendations,
    maxDropDownSuggestions,
    logger,
    showSearchComparisonCards,
    searchComparisonCardsData,
    contentForDropdownBox,
    styling,
    eidPrefix,
    suggestionsToDisplay,
    promptRecommendationsData,
    promptResult
  } = props;
  const customSuggestionsFlyoutItems = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "drop-down-list d-flex flex-column",
      "data-testid": "drop-down-suggestions",
      "aria-label": /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: "ariaLabel.searchBox.CustomSuggestionsDropdown"
      })
    }, /*#__PURE__*/_react.default.createElement(_CustomSuggestionsFlyoutItems.default, {
      iconsAndDomainsArray: suggestionsToDisplay,
      onClick: onConfirmCustomSuggestHandler,
      maxDropDownSuggestions: maxDropDownSuggestions,
      logger: logger,
      showContentForDropdownBox: !!contentForDropdownBox
    }));
  };
  const renderCustomSuggestions = () => {
    return showCustomSuggestions && (showSearchComparisonCards ? suggestionsToDisplay?.length >= 0 : suggestionsToDisplay?.length > 0) && /*#__PURE__*/_react.default.createElement(DropdownContentBlock, {
      styling: styling
    }, customSuggestionsFlyoutItems(), showSearchComparisonCards && searchComparisonCardsData ? (0, _SearchComparisonCardsContent.getDropdownVariant)({
      ...searchComparisonCardsData
    }) : '', contentForDropdownBox);
  };
  const renderPromptRecommendation = () => {
    return /*#__PURE__*/_react.default.createElement(DropdownContentBlock, {
      styling: styling,
      className: "flex-column"
    }, suggestionsToDisplay?.length > 0 && customSuggestionsFlyoutItems(), /*#__PURE__*/_react.default.createElement(_PromptFlyoutContent.PromptFlyoutContent, {
      prompts: promptRecommendationsData,
      eidPrefix: eidPrefix,
      styling: styling,
      promptResult: promptResult,
      logger: logger
    }));
  };
  if (showPromptRecommendations) {
    return renderPromptRecommendation();
  }
  return renderCustomSuggestions();
};
exports.SearchFlyoutContent = SearchFlyoutContent;
SearchFlyoutContent.propTypes = {
  onConfirmCustomSuggestHandler: _propTypes.default.func,
  showCustomSuggestions: _propTypes.default.bool,
  showPromptRecommendations: _propTypes.default.bool,
  promptRecommendationsData: _propTypes.default.object,
  maxDropDownSuggestions: _propTypes.default.number,
  logger: _propTypes.default.func,
  showSearchComparisonCards: _propTypes.default.bool,
  searchComparisonCardsData: _propTypes.default.object,
  contentForDropdownBox: _propTypes.default.node,
  suggestionsToDisplay: _propTypes.default.array,
  styling: _propTypes.default.object,
  eidPrefix: _propTypes.default.string,
  promptResult: _propTypes.default.object
};